<template>
  <Teleport to="body">
    <div v-if="modelValue" class="agreement-modal" @click.self="close">
      <div
        class="agreement-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="agreement-title"
      >
        <header class="agreement-head">
          <div>
            <p class="agreement-kicker">XING KONG · TERMS</p>
            <h3 id="agreement-title">星空素材网注册协议</h3>
          </div>
          <button type="button" class="agreement-close" @click="close" aria-label="关闭">
            ×
          </button>
        </header>

        <div class="agreement-body">
          <p class="lead">
            欢迎注册并使用星空素材网（以下简称「本站」）。在注册账号前，请仔细阅读本协议。一旦完成注册或勾选同意本协议，即视为您已充分理解并接受以下全部条款。
          </p>

          <section>
            <h4>一、账号注册与使用</h4>
            <ol>
              <li>您应使用本人常用、可正常接收邮件的邮箱完成注册，并妥善保管账号与密码。</li>
              <li>请勿将账号出租、出借、转让或以任何方式提供给他人使用。</li>
              <li>因账号保管不善、信息填写错误或授权信息不全导致的损失，由用户自行承担。</li>
              <li>抖音昵称及账号在抖音平台不允许修改，请按要求准确完善授权相关信息。</li>
            </ol>
          </section>

          <section>
            <h4>二、素材版权说明</h4>
            <ol>
              <li>本站素材资源归漫迷文创工作室及相关权利人所有，受著作权法保护。</li>
              <li>用户付费购买后仅获得约定范围内的个人使用权，不代表获得素材版权或转授权利。</li>
              <li>未经书面授权，不得将素材用于二次售卖、公开分发、破解、去水印转售等行为。</li>
              <li>本站素材最终解释权归权利人所有，如发生侵权使用，本站有权配合维权并追究责任。</li>
            </ol>
          </section>

          <section>
            <h4>三、授权与使用限制</h4>
            <ol>
              <li>每个用户可授权不超过 3 个账号使用相关资源，具体以页面说明或客服告知为准。</li>
              <li>超出授权范围、共享给未授权账号或用于商业转授权的，一经发现可暂停服务并依法追责。</li>
              <li>下载前请确认已登录；若提示登录过期，请重新登录后再试。</li>
            </ol>
          </section>

          <section>
            <h4>四、充值与服务</h4>
            <ol>
              <li>充值及会员相关服务以本站当前公示规则为准，具体办理方式可联系客服确认。</li>
              <li>因网络、第三方支付或用户自身操作导致的问题，本站将在合理范围内协助处理。</li>
              <li>如遇下载链接失效、无法下载或异常广告等情况，请通过页面右下角客服联系处理。</li>
            </ol>
          </section>

          <section>
            <h4>五、免责与协议变更</h4>
            <ol>
              <li>因不可抗力、系统维护、第三方服务异常等导致暂时无法访问的，本站将尽快恢复，但不就间接损失承担责任。</li>
              <li>本站有权根据业务需要修订本协议，修订后将通过站内公告等方式提示；继续使用即视为接受更新内容。</li>
              <li>本协议未尽事宜，以国家相关法律法规及本站公示规则为准。</li>
            </ol>
          </section>

          <p class="footer-note">
            运营主体：山西壹拾贰网络科技有限公司<br />
            如对本协议有疑问，请通过站内客服咨询。
          </p>
        </div>

        <footer class="agreement-foot">
          <button type="button" class="agreement-ok" @click="accept">
            我已阅读并同意
          </button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "accept"]);

const close = () => {
  emit("update:modelValue", false);
};

const accept = () => {
  emit("accept");
  emit("update:modelValue", false);
};
</script>

<style scoped lang="scss">
.agreement-modal {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(8, 20, 36, 0.55);
  backdrop-filter: blur(4px);
}

.agreement-panel {
  width: min(640px, 100%);
  max-height: min(82vh, 760px);
  display: flex;
  flex-direction: column;
  border-radius: 1.1rem;
  overflow: hidden;
  background: var(--xk-panel-bg, #fff);
  border: 1px solid var(--xk-line, rgba(11, 120, 196, 0.12));
  box-shadow: 0 24px 56px rgba(15, 40, 70, 0.28);
}

.agreement-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.15rem 1.25rem 1rem;
  background:
    radial-gradient(ellipse 70% 90% at 100% 0%, rgba(26, 155, 232, 0.18), transparent 55%),
    linear-gradient(180deg, color-mix(in srgb, var(--xk-soft, #eef6fc) 80%, #fff), var(--xk-panel-bg, #fff));
  border-bottom: 1px solid var(--xk-line, rgba(11, 120, 196, 0.12));
}

.agreement-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  letter-spacing: 0.16em;
  color: var(--xk-muted, #6b7f93);
}

.agreement-head h3 {
  margin: 0;
  font-size: 1.2rem;
  color: var(--xk-ink, #17324a);
  font-weight: 700;
}

.agreement-close {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: var(--xk-soft, #eef6fc);
  color: var(--xk-ink, #17324a);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.agreement-body {
  flex: 1;
  overflow: auto;
  padding: 1rem 1.25rem 0.5rem;
  color: var(--xk-ink, #17324a);
  -webkit-overflow-scrolling: touch;

  .lead {
    margin: 0 0 1rem;
    line-height: 1.7;
    color: var(--xk-muted, #5f7388);
    font-size: 0.9rem;
  }

  section {
    margin-bottom: 1rem;
  }

  h4 {
    margin: 0 0 0.45rem;
    font-size: 0.95rem;
    color: var(--xk-sky-deep, #0b78c4);
  }

  ol {
    margin: 0;
    padding-left: 1.15rem;
  }

  li {
    margin-bottom: 0.4rem;
    line-height: 1.65;
    font-size: 0.88rem;
    color: var(--xk-ink, #24384d);
  }

  .footer-note {
    margin: 0.35rem 0 1rem;
    padding: 0.85rem 0.95rem;
    border-radius: 0.75rem;
    background: var(--xk-soft, #eef6fc);
    color: var(--xk-muted, #5f7388);
    font-size: 0.82rem;
    line-height: 1.6;
  }
}

.agreement-foot {
  padding: 0.85rem 1.25rem 1.1rem;
  border-top: 1px solid var(--xk-line, rgba(11, 120, 196, 0.12));
  background: var(--xk-panel-bg, #fff);
}

.agreement-ok {
  width: 100%;
  border: none;
  border-radius: 0.75rem;
  padding: 0.78rem 1rem;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(90deg, var(--xk-sky-deep, #0b78c4), var(--xk-sky, #1a9be8));
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(11, 120, 196, 0.28);
  }
}
</style>
